import { FC, FormEvent } from 'react';
import { withForm } from 'react-bootstrap-formutil';
import BackNextButtons from 'components/BackNextButtons';
import QuestionnaireAnswer from 'components/forms/QuestionnaireAnswer';
import { usePowerNavigate } from 'components/PowerNavigate';
import security from 'stores/security';
import values from 'stores/values';

const QualificationQuestionnaire: FC = () => {
    const navigate = usePowerNavigate();

    const handleSubmit = (ev: FormEvent) => {
        ev.preventDefault();

        navigate(-1);
    };

    return (
        <form noValidate onSubmit={handleSubmit}>
            <QuestionnaireAnswer disabled />
            <BackNextButtons sticky hidePrev />
        </form>
    );
};

export default withForm(QualificationQuestionnaire, {
    $defaultValues: () => {
        values.setShowProgressBar(false);

        return security.customerInfo;
    }
});
